import ForgotPasswordAuth from 'modules/auth/ForgotPassword'

const ForgotPassword = () => {
  return <ForgotPasswordAuth />
};

export default ForgotPassword;
